// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.colorOption_pfyNF {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border: 1px solid transparent;
}

.optionRing_o7iNx {
  /* width: calc(100% - 4px);
  height: calc(100% - 4px); */
  width: 100%;
  height: 100%;
  border-radius: 50%;
  border: 2px solid var(--color-base100);
}

.innerOption_oGJP9 {
  width: 100%;
  height: 100%;
  border-radius: 50%;
}`, "",{"version":3,"sources":["webpack://./../../packages/recovr-plugins/lib/recovrGeneric/views/color/ColorOption.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE;6BAC2B;EAC3B,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB","sourcesContent":[".colorOption {\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  border: 1px solid transparent;\n}\n\n.optionRing {\n  /* width: calc(100% - 4px);\n  height: calc(100% - 4px); */\n  width: 100%;\n  height: 100%;\n  border-radius: 50%;\n  border: 2px solid var(--color-base100);\n}\n\n.innerOption {\n  width: 100%;\n  height: 100%;\n  border-radius: 50%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"colorOption": `colorOption_pfyNF`,
	"optionRing": `optionRing_o7iNx`,
	"innerOption": `innerOption_oGJP9`
};
export default ___CSS_LOADER_EXPORT___;
